export enum FilmRibbonsFields {
  width = "width",
  thickness = "thickness",
  otherThickness = "otherThickness",
  mainColor = "mainColor",
  otherMainColor = "otherMainColor",
  numberOfPrintColors = "numberOfPrintColors",
  designFile = "designFile",
  amountKg = "amountKg",
}
